<template>
    <section>
        <div class="top-option-block">
            <button :class="{ 'active': bookNumber === 1 }" @click="setActiveOption(1)">เล่ม 1</button>
            <button :class="{ 'active': bookNumber === 2 }" @click="setActiveOption(2)">เล่ม 2</button>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            bookNumber: -1
        }
    },
    mounted() {
        this.setActiveOption(1);
    },
    methods: {
        setActiveOption(book) {
            this.bookNumber = book;
            this.$emit('bookNumber', book)
        }
    }
}
</script>